<template>
  <div class="login_body">
    <header class="index_header">
      <div class="header_logo_container">
        <img src="./css/img/logo_nexus.svg" alt="Nexus brand logo" />
      </div>
    </header>
    <main class="index_main">
      <div class="main_left">
        <div class="promo_box">
          <img src="./css/img/pki.png" alt="Illustration of secure PKI" />
          <p>
            <span class="promo_line_1 text-none">All-in-One</span><br /><span class="promo_line_2"
              >PKI Management</span
            >
          </p>
        </div>
      </div>
      <div class="main_right">
        <div class="sign_in">
          <v-row>
            <global-logo-display :mdWidth="55" :lgWidth="70" :showVersion="true" />
          </v-row>
          <h1 class="page_title">Sign In</h1>
          <button class="button" @click="loginClicked()" v-if="!loading">
            <img
              class="logomark"
              src="./css/img/logomark_nexus_white.svg"
              alt="Nexus brand logomark"
            /><span>Start Personal Desktop Client</span>
          </button>
          <button v-if="loading" class="button progress">
            <img
              class="spinner animate-spin"
              src="./css/img/spinner.svg"
              alt="Progress indicator animated spinner"
            /><span>Pending signature...</span>
          </button>
          <a @click="clickedDownload()" v-if="this.downloadUrl">Download Personal Desktop Client</a>
          <div class="message_box" v-if="errorMessage">
            <div class="message_header">
              <i class="fa-light fa-circle-exclamation message_icon"></i>
              <h3 class="message_title">{{ errorMessage }}</h3>
            </div>
            <div class="message_body">
              {{ errorMessageBody }}
            </div>
          </div>
        </div>
      </div>
    </main>
    <footer class="index_footer">
      <div class="copyright">
        Copyright © 2023,
        <a href="https://www.nexusgroup.com/" target="_blank">Technology Nexus AB</a>.
        All rights reserved.
      </div>
    </footer>
  </div>
</template>

<script>
import GlobalLogoDisplay from "@/components/global/global-logo-display.vue";
import {mapActions, mapGetters} from "vuex";
import * as constants from "@/config/constants";
import router from "@/router/router"
import axios from "axios";

export default {
  components: {
    GlobalLogoDisplay,
  },
  data() {
    return {
      loginStatus: null,
      loading: false,
      errorMessage: "",
      errorMessageBody: "",
      downloadUrl: null
    };
  },
  props: {},
  async mounted() {
    await this.prepareDownloadUrl();

    if (router.currentRoute.path === constants.LOGOUT_ROUTE_PATH) {
      await this.logout();
      this.errorMessage = "Logged out";
      this.errorMessageBody = "You have signed out from CM Web UI, you can now close the window.";
    }
  },
  computed: {
    ...mapGetters(["getRoles"]),
  },
  methods: {
    ...mapActions(["login", "logout", "checkAuthStatus"]),
    loginClicked() {
      this.loading = true;
      this.login()
        .then(async () => {
          if (!constants.DASHBOARD_ROLES.every(role => this.getRoles.includes(role))) {
            this.setErrorMessage("notaccepted");
            await this.logout();
            return;
          }
          this.loading = false;
          await this.$router.push({ path: "/" });
        })
        .catch(() => {
          this.checkAuthStatus().then((res) => {
            this.setErrorMessage(res?.data?.status);
          }).catch(() => {
            this.setErrorMessage();
          });
        });
    },
    setErrorMessage(status) {
      this.loading = false;
      switch (status) {
        case "cancelled":
          this.errorMessage = "Sign-in Cancelled";
          this.errorMessageBody = "Sign-in process has been cancelled by the user.";
          break;
        case "notaccepted":
          this.errorMessage = "Unauthorized Officer Account";
          this.errorMessageBody =
              "Signing in is not allowed for the provided authentication credentials. Please make sure that correct credentials with appropriate access rights are used.";
          break;
        case "loggedout":
          this.errorMessage = "Sign-in Timeout";
          this.errorMessageBody =
              "The sign-in session has exceeded its time limit. Please check your connectivity and try again or contact your administrator if the problem persists.";
          break;
        case "failed":
        default:
          this.errorMessage = "Sign-in Failed";
          this.errorMessageBody =
              "The sign-in process has been interrupted due to an unexpected error. Please contact your administrator if the problem persists.";
          break;
      }
    },
    async prepareDownloadUrl() {
      const url = constants.PERSONAL_INSTALL_LOCATIONS.find(entry =>
          new RegExp(entry.userAgentRegex, "i")
              .test(navigator.userAgent))?.url;

      if (url) {
        try {
          let res = await axios.head(url);
          if (res.status === 200) {
            this.downloadUrl = url;
          }
        } catch (err) {
        }
      }
    },
    async clickedDownload() {
      if (!this.downloadUrl) {
        return;
      }

      fetch(this.downloadUrl)
          .then(async (res) => {
            if (!res.ok) {
              throw new Error();
            }
            const a = document.createElement("a");
            a.href = window.URL.createObjectURL(await res.blob());
            a.download = this.downloadUrl.substring(this.downloadUrl.lastIndexOf('/') + 1);
            a.click();
          })
          .catch(() => {
            this.errorMessage = "Error";
            this.errorMessageBody =
                "Cannot download Personal desktop, file might be missing on server or other connection issues, contact server admin";
          });
    },
  },
};
</script>

<style lang="scss">
@import "./css/main.css";
</style>
